import request from '../request'
import apis from '../apis'

export default {
    // 获得浏览记录
    getBrowseHistoryList(params) {
        return request.get(apis.GET_BROWSE_HISTORYLIST, { params });
    },
    // 查询酒店列表
    getHotelListData({ params, pageVO }) {
        return request.post(`${apis.POST_HOTEL_LIST}/${pageVO.pageSize}/${pageVO.curPage}`, params)
    },
    // 查询lookup
    getLookUpData(params) {
        return request.get(apis.COMMON_LOOKUP_DATA, { params });
    },
    getRoomTypeData(params) {
        return request.post(apis.POST_ROOMTYPE_LIST, params)
    },
    // 获得余量列表
    getMininumRemainingVolume(params) {
        return request.post(apis.POST_REMAININGVOLUME_LIST, params)
    },
    // 获得排队人数
    getRoomWaitingCount(params) {
        return request.post(apis.POST_WAITING_COUNT, params)
    },
    // 查询酒店详情信息
    getDetailBasieinfo(params) {
        return request.get(apis.GET_DETAIL_BASIEINFO, { params });
    },
    // 新增收藏
    insertSingle(params) {
        return request.post(apis.POST_INSERT_SINGLE, params)
    },
    // 取消收藏
    updateSingle(params) {
        return request.post(apis.POST_UPDATE_SINGLE, params)
    },
    // 校验团组
    isExistGroup(params) {
        return request.get(apis.GET_ISEXIST_GROUP, { params });
    },
    // 新增浏览记录
    addBrowseHistory(params) {
        return request.post(apis.POST_ADD_BROWSE_HISTORY, params)
    },
    // 获得入住人数上限和房间上限
    getMainRule(params) {
        return request.get(apis.GET_MAIN_RULE, { params });
    },
    countOrderCost(params) {
        return request.post(apis.COUNT_ORDER_COST, params)
    },
    getAvailableGroupBudget(params) {
        return request.get(apis.GET_AVALIABLE_GROUP_BUDGET, params)
    },
    findHotelRoomTypeInfo(params) {
        return request.get(apis.FIND_HOTEL_ROOM_TYPEINFO, params)
    },
    getHotelLockObj(params) {
        return request.get(apis.GET_LOCK_OBJ, params)
    },
    // 获取预订人信息
    getPesonInfo(params) {
        return request.get(apis.GET_FINGUSERINFO, params)
    },
    // 提交酒店订单
    clickSubmitOrder(params) {
        return request.post(apis.POST_ORDERADD, params)
    },
    // 获取酒店订单详情
    getHotelOrderDetail(params) {
        return request.get(apis.GET_HOTEL_ORDER_DETAIL, { params });
    },

    findGeographyInfoPagedList(params) {
        return request.get(apis.GET_COUNTRY_LIST, params)
    }
}
